import React from 'react';
import './footer.css';

function Footer() {
  return (
    <footer id="main-footer">
      <div className="container">
        <span style={{ color: '#ffffff', marginTop: 3, marginLeft: -17 }} >Eurosistemas MT</span>
        <span style={{ color: '#ffffff', marginTop: 3, float: "right", fontSize: 11, marginRight: 40 }}>
          Versão 2.0</span>
      </div>
    </footer>
  );
}

export default Footer;